<template>
    <div>
        <div v-if="loading" class="mr-1" style="display: inline-block">
            <loading align="left" size="1"></loading>
        </div>
        {{ $root.text('processing', null, true) }}
        {{ progress }}%
        <div class="asset-overall-progress mt-2">
            <div class="asset-overall-upload" :style="'width: ' + progress + '%'"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['task_id'],
        data () {
            return {
                loading: true,
                progress: 0,
                asset_ids: null
            }
        },
        mounted () {
            var vm = this;
            // Check status in 20 seconds.
            setTimeout(function () {
                vm.getStatus(vm.task_id);
            }, 1000 * 20);
        },
        watch: {
            //
        },
        methods: {
            getStatus: function (taskId) {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/resource-files-status/' + taskId;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    if (!vm.loading || !vm.$root.adding_asset) {
                        return null;
                    }
                    if ((response.data.status == 'Pending') || (response.data.status == 'In progress')) {
                        if ((vm.progress === null) || (response.data.progress > vm.progress)) {
                            vm.progress = (response.data.progress < 100) ? Math.round(response.data.progress) : 100;
                        } else {
                            vm.progress++;
                        }
                        // Check status again in 10 seconds.
                        var taskId = response.data.task_id;
                        setTimeout(function () {
                            vm.getStatus(taskId);
                        }, 1000 * 10);

                        return null;
                    }
                    // Completed.
                    vm.loading = false;
                    vm.progress = response.data.progress;
                    vm.asset_ids = response.data.resources;
                    vm.$parent.onClose(
                        true,
                        { name: 'assets-filtered', params: { filters: 'id::' + response.data.resources.join(',') } }
                    );
                })
                .catch(function (error) {
                    //
                });
            }
        }
    }
</script>
<style scoped>
    .asset-overall-progress {
        position: relative;
        height: 8px;
        overflow: hidden;
        border-radius: 4px;
    }

    .asset-overall-upload {
        height: 8px;
    }
</style>
